import React from "react";
import logo from'../logo.png';
import key from'../key.png';

export default function Form() {
   
      return (
      <div className="form-main">
        <div className="form-content">
            <img className="form-logo" src={logo} alt="" />
            <img className="form-key"  src={key} alt="" />
      <p>Join the club</p>
      <div className="fields">
        <input className="Form-input" placeholder="Email address" type="text" />
        <button className="Form-submit">Go</button>
      </div>
        </div>
      </div>
      );
}
